import MaterialIconButton from "@mui/material/IconButton";
import React, { ButtonHTMLAttributes, forwardRef } from "react";

interface Props extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "color"> {
	className?: string;
	size?: "medium" | "small";
}

// forwardRef so wrappers that need the underlying button node - e.g.
// next/link's non-legacy Link, or styled-components measuring it - can get
// one instead of React warning that a plain function component was given a
// ref that goes nowhere.
const IconButton = forwardRef<HTMLButtonElement, Props>(
	({ className, size = "medium", children, ...buttonProps }, ref) => {
		return (
			<MaterialIconButton
				ref={ref}
				className={className}
				size={size}
				{...buttonProps}
			>
				{children}
			</MaterialIconButton>
		);
	},
);
IconButton.displayName = "IconButton";

export { IconButton };
